<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>VENUE<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView"(click)="save($event)"class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="Venue" [actionExclude]="['feedback','column']" [checkboxCol]="true"
        [entityColumns]="VenueColumns" [selectionField]="'Venue_Id'" [addEntityIcon]="'bi bi-plus-square'"
        [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (addEntity)="addVenue($event)"
        (downloadEntities)="onExcelExport()" (editEntity)="editVenue($event)"
        (refreshEntities)="refreshDepartments($event)" (deleteEntity)="deleteVenue($event)" 
        (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
        [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)" >
    </grid>

    </div>

    <div *ngIf="!listView">  
        <div class="row sub-head"> 
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearVenue()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div> 
        </div>
        
        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Venue Type'" [formData]="entity" [data]="basicmaster" [class] = "'form-control'"
                    [mandatory]="true" [filterable]="true" (filterChanged)="getAllVenue_type($event)"
                    [(ngModel)]="entity.Venuetype_Id" [textField]="'DisplayText'" [valueField]="'DisplayValue'"
                    [fieldName]="'Venuetype_Id'" [selectedItem]="selectedvenue" ngDefaultControl>
                </dropdown>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Venue Name'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                                [fieldName]="'VenueName'" [(ngModel)]="entity.VenueName " ngDefaultControl>
                            </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="' Address'" [formData]="entity"  [multiline]="true" [maxlength]="500" [mandatory]="true"
                            [fieldName]="'VenueAddress'" [(ngModel)]="entity.VenueAddress"  ngDefaultControl>
                        </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <!-- <textbox [caption]="'Phone'" [formData]="entity" [maxlength]="10" [mandatory]="true"
                    [fieldName]="'Phone'" [(ngModel)]="entity.Phone" (keypress)="numberOnly($event)" ngDefaultControl>
                </textbox> -->
                <dropdown [caption]="'Facility Manager Name'" [formData]="entity" [data]="facilitymanagers" [class] = "'form-control'"
                [mandatory]="false" [filterable]="true" (filterChanged)="getAllFacilityManagers($event)"
                [(ngModel)]="entity.FacilityManager_Id" [textField]="'FacilityManagerName'" [valueField]="'FacilityManager_Id'"
                [fieldName]="'FacilityManagerName'" [selectedItem]="selectedFacilitymanger" ngDefaultControl>
            </dropdown>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="' Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'" [type]="'button'"
                        title="Back Tab"></btn>
                </div>
                <div class="col-md-4">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
            </div> -->
        </div>
       
    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="Venu Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
        <div class="col-md-4 br-table-data">
            <label for="VenuetypeName" class="label label-1">Venue Type : </label> {{details.VenuetypeName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="VenueName" class="label label-1">Venu Name : </label> {{details.VenueName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="VenueAddress" class="label label-1">Venue Address : </label> {{details.VenueAddress}}
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="FacilityManagerName" class="label label-1">Facility Manager Name : </label> {{details.FacilityManagerName}}
          </div>
        </div>
        </div>
    </kendo-dialog>
<kendo-excelexport [data]="Venue.data" [collapsible]="true" fileName="VenueeMaster.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="VenueName" title="Venue" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="VenueAddress" title="Address" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="VenuetypeName" title="Venue Type" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column> 

</kendo-excelexport>